import type { Location } from '@functieloonhuis/shared';
import { DAY_LABELS_FULL, WORKWEEK_DAYS } from '../utils/weekUtils';

interface OrgScheduleFiltersProps {
  selectedDepartment: number | null;
  selectedDay: number | null;
  selectedLocation: Location | null;
  departments: Array<[number, string]>;
  onDepartmentChange: (departmentId: number | null) => void;
  onDayChange: (day: number | null) => void;
  onLocationChange: (location: Location | null) => void;
}


export function OrgScheduleFilters({
  selectedDepartment,
  selectedDay,
  selectedLocation,
  departments,
  onDepartmentChange,
  onDayChange,
  onLocationChange,
}: OrgScheduleFiltersProps) {
  const hasActiveFilters = selectedDepartment !== null || selectedDay !== null || selectedLocation !== null;

  const clearFilters = () => {
    onDepartmentChange(null);
    onDayChange(null);
    onLocationChange(null);
  };

  return (
    <div className="flex flex-wrap items-center gap-4">
      {/* Department filter */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">Team:</span>
        <select
          value={selectedDepartment ?? ''}
          onChange={(e) => onDepartmentChange(e.target.value ? parseInt(e.target.value, 10) : null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Alle teams</option>
          {departments.map(([id, name]) => (
            <option key={id} value={id}>{name}</option>
          ))}
        </select>
      </div>

      {/* Day filter */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">Dag:</span>
        <select
          value={selectedDay ?? ''}
          onChange={(e) => onDayChange(e.target.value ? parseInt(e.target.value, 10) : null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Alle dagen</option>
          {WORKWEEK_DAYS.map(day => (
            <option key={day} value={day}>{DAY_LABELS_FULL[day]}</option>
          ))}
        </select>
      </div>

      {/* Location filter */}
      <div className="flex items-center gap-2">
        <span className="text-sm text-gray-500">Locatie:</span>
        <select
          value={selectedLocation ?? ''}
          onChange={(e) => onLocationChange((e.target.value || null) as Location | null)}
          className="px-3 py-1.5 text-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Alle</option>
          <option value="kantoor">Kantoor</option>
          <option value="thuis">Thuis</option>
        </select>
      </div>

      {/* Clear filters */}
      {hasActiveFilters && (
        <button
          type="button"
          onClick={clearFilters}
          className="text-sm text-blue-600 hover:text-blue-800"
        >
          Filters wissen
        </button>
      )}
    </div>
  );
}
